import { render, staticRenderFns } from "./MySelfHelpGroups.vue?vue&type=template&id=052f47e4"
import script from "./MySelfHelpGroups.vue?vue&type=script&setup=true&lang=js"
export * from "./MySelfHelpGroups.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports